import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { dsCoreStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { dsCoreStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

const DsCoreAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dsCoreAuthUrl, setDsCoreAuthUrl] = useState('');
    const dsCoreFrontendStatus = dsCoreStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('dsCore-auth-callback');

    useQuery(dsCoreStatusTemplate, {
        onCompleted: ({ dsCoreStatus }: { dsCoreStatus: ScannerCaseAuthStatus }) => {
            dsCoreStatusVar(dsCoreStatus);
            if (dsCoreStatus.enabled && !dsCoreStatus.authorized && !isCurrentlyAuthorizing) {
                setDialogOpen(true);
                const url = `${CONSTANTS.DS_CORE_AUTH_URL}/secureLogin?client_id=${dsCoreStatus.clientId}&code_challenge=${dsCoreStatus.codeChallenge}&redirect_uri=${CONSTANTS.DS_CORE_AUTH_REDIRECT}`;
                console.log('DS Core auth url', url);
                setDsCoreAuthUrl(url);
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {dsCoreFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('scan-cases:YOU_NEED_TO_LOGIN_TO_DS_CORE')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:DS_CORE_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={dsCoreAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_DS_CORE')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default DsCoreAuthContainer;
